/* global NEWPORTAL */
import news_data from './data';
import NewsSlider from './slider';

export default (function () {
    return {
        selectors: {
            topCarousel: '#carousel_slider_top',
            bottomCarousel: '#carousel_slider_bottom'
        },
        getOrderedCategories: function(categories) {
            var categoryOrder = NEWPORTAL.news_conf.category_order_importance;

            return categories
            //get categories
                .sort(function(a, b){
                    var aOrderVal = typeof categoryOrder[a.name] !== "undefined" ? categoryOrder[a.name] : 0;
                    var bOrderVal = typeof categoryOrder[b.name] !== "undefined" ? categoryOrder[b.name] : 0;

                    return bOrderVal-aOrderVal;
                });
        },
        getOrderedNewsSources: function(sources, topSource) {
            var sourceOrder = NEWPORTAL.news_language.source_order_importance  || [];
            //override source position to be the last on if this source is chosen in top slider
            if (topSource) {
                sourceOrder[topSource] = -1;
            }
            return sources
                //sort by order defined in parameters.yml
                .sort(function(a, b){
                    var aOrderVal = typeof sourceOrder[a.sourceName] !== "undefined" ? sourceOrder[a.sourceName] : 0;
                    var bOrderVal = typeof sourceOrder[b.sourceName] !== "undefined" ? sourceOrder[b.sourceName] : 0;

                    return bOrderVal-aOrderVal;
                });
        },
        getNewsSource: function (carouselId, newsItem) {
            const sources = news_data.sliderArticles[carouselId].sources;

            if (newsItem.source && typeof newsItem.source !== "string") {
                return newsItem.source;
            }

            return sources.filter(value => value.sourceName == newsItem.source)[0];
        },
        fillTopSlider: function(newsItems, categories, sources, categoryType, categoryChosen) {
            // Set all data needed for each slider
            categories = this.getOrderedCategories(categories);
            news_data.setFilteredSliderData('carousel_slider_top', newsItems, categories, sources);

            var
                smallItemTopSmallClasses = 'col-6 col-md-4 col-lg-6',
                smallItemTopBigClasses = 'd-none d-md-block col-md-4 d-lg-none',
                slideTopSmallNewsClasses = ' col-12 hidden-sm d-md-none d-lg-block d-xl-block d-md-block col-lg-12',
                slideTopBigNewsClasses = ' visible-xxl-block col-widget-2',
                additionalMainNewsWrapperClasses = '',
                bigItemWrapperClasses = 'col-xxl-6';

            this.topSlider = new NewsSlider(
                this.selectors.topCarousel,
                categories,
                categoryType,
                categoryChosen,
                slideTopSmallNewsClasses,
                slideTopBigNewsClasses,
                smallItemTopSmallClasses,
                smallItemTopBigClasses,
                additionalMainNewsWrapperClasses,
                bigItemWrapperClasses
            );
            // First slide before page load
            var firstMainNewsItem = newsItems.shift();
            var firstSmallNewsItems = newsItems.splice(0, 6);
            var firstBigNewsItems = newsItems.splice(0, 4);
            this.topSlider.addSlide(1, firstMainNewsItem, firstSmallNewsItems, firstBigNewsItems);

            var that = this;

            // for other slides wait till document is ready
            $(function () {
                let slideNo = 1;
                for (let i = 1; i < newsItems.length; i++) {
                    if(newsItems.length < 10) {
                        break;
                    }
                    if (i > 10) {
                        break;
                    }
                    slideNo = i + 1;
                    var mainNewsItem = newsItems.shift();
                    var smallNewsItems = newsItems.splice(0, 6);
                    var bigNewsItems = newsItems.splice(0, 4);
                    that.topSlider.addSlide(slideNo, mainNewsItem, smallNewsItems, bigNewsItems);
                }
                that.topSlider.renderSlide(1);
                that.topSlider.renderSlide(2);
                that.topSlider.renderSlide(slideNo);
                that.topSlider.newsCarouselInit();
            });

            return newsItems;
        },
        fillBottomSlider: function(newsItems, categories, sources, categoryType, categoryChosen) {

            //do not show top provider's news item in bottom "all" category
            if (categoryChosen == news_data.categoryAll) {
                var topProvider = news_data.getTopProvider();
                newsItems = newsItems.filter(function(value){
                    return value.source != topProvider;
                });
            }

            sources = this.getOrderedNewsSources(sources, news_data.getTopProvider());
            news_data.setFilteredSliderData('carousel_slider_bottom', newsItems, categories, sources);

            var smallItemBottomSmallClasses = 'col-6 col-md-4';
            var smallItemBottomBigClasses = 'col-6 col-md-4 hidden-sm';
            var slideBottomSmallNewsClasses = ' col-12 col-sm-6 col-lg-12 col-xxl-6';
            var slideBottomBigNewsClasses = ' col-12 visible-xxl-block col-widget-6';
            var additionalMainNewsWrapperClasses = 'col-12 col-xxl-6';
            var bigItemWrapperClasses = 'col-xxl-4';

            //var bottomSlider = new NewsSlider(
            this.bottomSlider = new NewsSlider(
                this.selectors.bottomCarousel,
                sources, //use sources for categories
                categoryType,
                categoryChosen,
                slideBottomSmallNewsClasses,
                slideBottomBigNewsClasses,
                smallItemBottomSmallClasses,
                smallItemBottomBigClasses,
                additionalMainNewsWrapperClasses,
                bigItemWrapperClasses
            );
            //first slide before page load
            var firstMainNewsItem = newsItems.shift();
            var firstSmallNewsItems = newsItems.splice(0, 6);
            var firstBigNewsItems = newsItems.splice(0, 3);
            this.bottomSlider.addSlide(1, firstMainNewsItem, firstSmallNewsItems, firstBigNewsItems);

            var that = this;

            //other slides on window load
            $(document).ready(function() {
                var slideNo = 1;
                for (var i = 1; i < newsItems.length; i++) {
                    if(newsItems.length < 10) {
                        break;
                    }
                    if (i > 10) {
                        break;
                    }
                    slideNo = i+1;
                    var mainNewsItem = newsItems.shift();
                    if (!mainNewsItem) {
                        break;
                    }
                    var smallNewsItems = newsItems.splice(0, 6);
                    var bigNewsItems = newsItems.splice(0, 3);
                    that.bottomSlider.addSlide(slideNo, mainNewsItem, smallNewsItems, bigNewsItems);
                }

                that.bottomSlider.renderSlide(1);
                that.bottomSlider.renderSlide(2);
                that.bottomSlider.renderSlide(slideNo);
                that.bottomSlider.newsCarouselInit();
            });
        },

        //dropdown does not work well in bootstrap5 here so we have our own custom implementation for clicks
        handleMoreCategoriesClick: () => {
            document.addEventListener('click', function (event) {
                const closestMoreNewsEl = event.target.closest('.news-more');
                if (!closestMoreNewsEl) {
                    //find all open categories more dropdowns and close them
                    document.querySelectorAll('.news-more.open').forEach((newsMoreItem) => {
                        newsMoreItem.classList.remove('open');
                    });
                    return;
                }
                closestMoreNewsEl.classList.toggle('open');
            }, false);
        },

        // updates slider when category is clicked
        updateSliderWithCategoryData: function (
            currCategoryType,
            sourceId,
            categoryId,
            currCategoryChosen,
            carouselToUpdateId
        ) {
            var linkTemplate = NEWPORTAL.widget_apis.news_template;
            var that = this;

            news_data.getFeedData(
                linkTemplate.url,
                linkTemplate.fallback_url,
                currCategoryType,
                sourceId,
                categoryId,
                function (feedData) {
                    if (carouselToUpdateId === "carousel_slider_top") {
                        that.fillTopSlider(feedData.articles, feedData.categories, feedData.sources, currCategoryType, currCategoryChosen);
                    } else {
                        that.fillBottomSlider(feedData.articles, feedData.categories, feedData.sources, currCategoryType, currCategoryChosen);
                    }
                }
            );

            // To slow down fast category clickers
            setTimeout(() => {
                NEWPORTAL.isCategoryLoaded = true;
            }, 400);
        }
    };
}());
